export class HlPercentageInfo{
    minGrade:number;
    maxGrade:number;
    hlPercentage:number;
}